module.exports = __webpack_public_path__ + "img/ic_info.8d36725f.svg";